// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h8","input":"h9","button":"h-"};